import { Alert, Checkbox } from '@patternfly/react-core';
import { useTranslation } from 'react-i18next';
import { ConcurrentSaveError } from '../util/errors';

import './concurrent-save-error-alert.css';

interface ConcurrentSaveErrorAlertProps {
    concurrentSaveError: ConcurrentSaveError | null | undefined;
    forceOverwrite: boolean;
    onForceOverwriteChange: (checked: boolean) => void;
}

export const ConcurrentSaveErrorAlert = ({ concurrentSaveError, forceOverwrite, onForceOverwriteChange }: ConcurrentSaveErrorAlertProps) => {
    const { t } = useTranslation();

    if (concurrentSaveError == null) { return null; }

    return (
        <div className="concurrent-save-error-alert-container">
            <Alert
                variant="warning"
                isInline
                title={t('customizationToolbar.save.concurrentError.title')}
                className="pf-v5-u-mt-md conflict-alert-appear concurrent-save-error-alert"
                data-testid="concurrent-save-error-alert"
            >
                <p>{t('customizationToolbar.save.concurrentError.message')}</p>
            </Alert>
            <Checkbox
                id="force-overwrite-checkbox"
                label={t('customizationToolbar.save.concurrentError.forceCheckbox')}
                isChecked={forceOverwrite}
                onChange={(_event, checked) => onForceOverwriteChange(checked)}
                className="pf-v5-u-mt-md"
                data-testid="force-overwrite-checkbox"
            />
        </div>
    );
};
